import React from 'react';
import Karuselli from './Karuselli';

function SahkotyotSv() {
  return (
    <div className="page-wrapper">
      <div className="page-content">
        <h1>Elarbeten</h1>
        <p></p>
          <h4>- Kabeldragning</h4>
          <h4>- Kopplingar / Mätningar</h4>
          <h4>- Mätkontrollprotokoll för byggnadsinspektion och slutbesiktning</h4>
          <h4>- S2-tillstånd</h4>
      </div>
      <div className="carousel-container">
     {/*   <Karuselli folder="sahkotyot" imageCount={} />  */}
      </div>
    </div>
  );
}

export default SahkotyotSv;
